import React from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";

import { PendingApprovalAlertProps } from "@LeagueManagement/Organizations/types/organizations";

const PendingApprovalAlert = ({
    pendingApproval,
}: PendingApprovalAlertProps): React.JSX.Element => {
    return (
        <Alert
            variant="warning"
            className="col-6 col-offset-3 mx-auto mb-5 text-center"
        >
            <Alert.Heading as="h5">Pending Organization Changes</Alert.Heading>
            <p className="p-0 m-0">
                The following organizations have pending changes to review:
            </p>
            <ul className="text-left list-unstyled mb-0">
                {pendingApproval?.map(o => (
                    <li key={o.id}>
                        <Link
                            to={`edit/${o.id}`}
                            className="text-decoration-none text-primary"
                        >
                            {o.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </Alert>
    );
};

export default PendingApprovalAlert;
